import { render, staticRenderFns } from "./track-lyrics.vue?vue&type=template&id=1d377ee8"
import script from "./track-lyrics.vue?vue&type=script&lang=js"
export * from "./track-lyrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports